import { NUMBER } from "../../constants/app-constants";

export default (mobile, limit = null) => {
    if (limit) {
        return mobile.substr(-limit);
    } else {
        return mobile.substr(-NUMBER.FOUR);
    }
};
